export default __webpack_public_path__ + "static/giphysdk-promo-e80f0e360aefe246a349cb1bf004ea3a.gif";